// extracted by mini-css-extract-plugin
export default {"NormalizeMarginTopDifference":"_NormalizeMarginTopDifference--A6c0b"};